import React, { createContext, useState, useEffect } from "react";
import { getProperties } from "../application/getProperties";

export const HouseContext = createContext();

const HouseContextProvider = ({ children }) => {
  const [houses, setHouses] = useState([]); // Lista filtrada actual
  const [allHouses, setAllHouses] = useState([]); // Todas las casas sin filtrar
  const [country, setCountry] = useState("Todas las localidades");
  const [countries, setCountries] = useState([]);
  const [property, setProperty] = useState("Todas las Propiedades");
  const [properties, setProperties] = useState([]);
  const [price, setPrice] = useState("Rango de Precio");
  const [state, setState] = useState("Todos los estados");
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchHouses = async () => {
      let timeoutId;
      try {
        setLoading(true);
        const timeoutPromise = new Promise((_, reject) => {
          timeoutId = setTimeout(() => {
            reject(new Error("La consulta a la base de datos tardó demasiado"));
          }, 5000); // 5 segundos
        });

        const data = await Promise.race([getProperties(), timeoutPromise]);

        clearTimeout(timeoutId);

        // Asignar los datos a allHouses y houses
        setAllHouses(data);
        setHouses(data);

        // Extraer y establecer valores únicos para filtros
        const allCountries = data.map((house) => house.country);
        const uniqueCountries = [
          "Todas las localidades",
          ...new Set(allCountries),
        ];
        setCountries(uniqueCountries);

        const allProperties = data.map((house) => house.type);
        const uniqueProperties = [
          "Todas las Propiedades",
          ...new Set(allProperties),
        ];
        setProperties(uniqueProperties);

        const allStates = data.map((house) => house.state);
        const uniqueStates = ["Todos los estados", ...new Set(allStates)];
        setStates(uniqueStates);
      } catch (error) {
        console.error("Error al obtener casas:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchHouses();
  }, []);

  const handleClick = () => {
    setLoading(true);

    const minPrice = parseInt(price.split(" ")[0]);
    const maxPrice = parseInt(price.split(" ")[2]);

    // Filtrar utilizando los datos obtenidos de Google Sheets
    const newHouses = allHouses.filter((house) => {
      const housePrice = parseInt(house.price);

      return (
        (country === "Todas las localidades" || house.country === country) &&
        (property === "Todas las Propiedades" || house.type === property) &&
        (state === "Todos los estados" || house.state === state) &&
        (price === "Rango de Precio" ||
          (housePrice >= minPrice && housePrice <= maxPrice))
      );
    });

    setTimeout(() => {
      setHouses(newHouses.length < 1 ? [] : newHouses);
      setLoading(false);
    }, 1000);
  };

  // Función para resetear filtros y mostrar todas las casas
  const handleResetFilters = () => {
    setCountry("Todas las localidades");
    setProperty("Todas las Propiedades");
    setState("Todos los estados");
    setPrice("Rango de Precio");
    setHouses(allHouses); // Mostrar todas las casas
  };

  return (
    <HouseContext.Provider
      value={{
        country,
        setCountry,
        countries,
        property,
        setProperty,
        properties,
        price,
        setPrice,
        state,
        setState,
        states,
        handleClick,
        handleResetFilters, // Agregar función para resetear los filtros
        houses,
        loading,
      }}
    >
      {children}
    </HouseContext.Provider>
  );
};

export default HouseContextProvider;
